import { jsx as r, jsxs as N } from "react/jsx-runtime";
import F, { useState as T, useRef as j } from "react";
import { TextInput as q } from "./textInput.js";
import { S as G } from "./cancelCloseFilled-b2127cb6.mjs";
import { u as v } from "./index-6a632112.mjs";
import { S as K, D as M, a as H, A as W } from "./searchInputLocation.const-9a2c3a62.mjs";
import { m as X, s as f, r as z } from "./themes-5f0b3c3d.mjs";
import { D as d } from "./index-39f84169.mjs";
import { u as J } from "./uniqueId-321287e8.mjs";
import "./lineHeights-72d3110c.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "./label-3b996c7d.mjs";
import "./tooltip.js";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./button.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./helperText-698f3ed9.mjs";
import "./warningFilled-691cfde1.mjs";
import "./radio.js";
import "./checkbox.js";
import "./checkmark-84b5274e.mjs";
import "./subtract-848336fd.mjs";
import "./menu.js";
import "./moreVertical-dc2e97a2.mjs";
const _ = "SearchInputLocation", Q = v.div`
  position: relative;
  width: 100%;
  div[role='region'] {
    display: ${({ $isShow: p }) => p ? "block" : "none"} !important;
  }

  > div {
    width: 100%;
  }
`, Y = v.button`
  display: flex;
  align-items: center;
  && > svg {
    color: ${X["neutral-strong"]};
  }
  padding: unset;
  background-color: unset;
  border: unset;
  &&.closeBtn {
    padding: ${f["1x"]};
    border-radius: ${z["2x"]};
  }
`;
function Pe({
  textSize: p = "medium",
  longitude: b = M,
  latitude: A = H,
  apiKey: D,
  value: o = { inputValue: "", selectedValue: "" },
  limit: g = 5,
  disabled: i,
  isRequired: U = !1,
  required: h = U,
  helperText: L = "",
  isError: u = !1,
  helperTextProp: S = {
    [u ? "secondaryProp" : "defaultProp"]: {
      helperText: L,
      id: `${u ? "invalid" : "valid"}_${_}_helperText`,
      ...u && { state: "error" }
    }
  },
  placeholder: w = "Enter your address...",
  onChange: s,
  onBlur: C,
  labelProp: x,
  infoProp: P,
  trailingText: R,
  noResultText: E,
  ...O
}) {
  const n = F.useRef(null), [c, a] = T(!1), I = j(J(_)), [l, V] = T(
    []
  ), k = {
    inputValue: "",
    selectedValue: ""
  }, B = (e) => {
    const t = e.target.value;
    if (s({
      inputValue: t,
      selectedValue: o?.selectedValue
    }), t.length > 1) {
      const y = `${W}${A},${b}&limit=${g}&lang=en&q=${t}&apiKey=${D}`;
      fetch(y).then((m) => m.json()).then((m) => V(m.items));
    } else
      V([]);
    t.length > 0 ? a(!0) : a(!1);
  }, $ = (e) => {
    n && n.current && (n.current.click(), n.current.focus()), e.stopPropagation(), s(k), a(!1);
  };
  return /* @__PURE__ */ r(
    Q,
    {
      $isShow: c,
      "aria-disabled": i,
      "aria-required": h,
      "aria-label": x?.label,
      children: /* @__PURE__ */ N(
        d,
        {
          menuOpen: !i && c,
          onChange: (e, t) => {
            s?.({
              inputValue: t.label,
              selectedValue: t.label
            }), n.current?.focus();
          },
          handleMenuOpen: (e) => {
            e ? o?.inputValue?.length > 0 && l?.length > 0 && a(e) : a(e);
          },
          isDisabled: i,
          uniqueIdentifier: I.current,
          maxItems: Number(g),
          closeOnSelect: !0,
          noResultText: E || "No location found",
          children: [
            /* @__PURE__ */ r(d.Control, { children: /* @__PURE__ */ r(
              q,
              {
                labelProp: { label: K, ...x },
                infoProp: {
                  infoText: "",
                  infoType: "tooltip",
                  popupTipHeader: "Info",
                  ...P
                },
                id: `control-${I.current}`,
                endAdornmentProp: {
                  endAdornment: o.inputValue && !i ? /* @__PURE__ */ r(
                    Y,
                    {
                      onClick: $,
                      id: "closeButton",
                      className: "closeBtn",
                      onKeyDown: (e) => {
                        (e.code === "Enter" || e.code === "Space") && (e.preventDefault(), $(e));
                      },
                      children: /* @__PURE__ */ r(
                        G,
                        {
                          style: {
                            cursor: "pointer",
                            height: f["4x"],
                            width: f["4x"]
                          }
                        }
                      )
                    }
                  ) : void 0
                },
                value: o.inputValue,
                type: "text",
                textSize: p,
                required: h,
                inputRef: n,
                onChange: B,
                disabled: i,
                placeholder: w,
                onBlur: C,
                helperTextProp: c ? {
                  secondaryProp: {
                    state: S?.secondaryProp?.state || "none"
                  }
                } : S,
                onKeyUp: (e) => {
                  e.key === " " && e.stopPropagation();
                },
                trailingText: R,
                ...O
              }
            ) }),
            o?.inputValue?.length > 0 && l && l?.length > 0 && l?.map(({ title: e, id: t }, y) => /* @__PURE__ */ r(
              d.Item,
              {
                id: t,
                label: e,
                value: e,
                isSelected: o.selectedValue === e
              },
              t
            ))
          ]
        }
      )
    }
  );
}
export {
  Pe as SearchInputLocation
};
